module.exports = __webpack_public_path__ + "fonts/sourcesanspro-extralight-webfont.085fbb71.woff";